import React, { Component } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import { getProjects } from "../../../../services/projectService";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { DialogContentText } from "@material-ui/core";
import { cloneForm } from "../../../../services/formService";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import { logActivity } from '../../../../services/utilService';

class CloneFormDialog extends Component {
  state = {
    Projects: [],
    Project_ID: this.props.Project_ID,
    Form_ID: this.props.Form.Form_ID,
    Form_Name: this.props.Form.Form_Name,
    New_Form_Name: this.props.Form.Form_Name,
    Destination_Project: this.props.Project_ID ? parseInt(this.props.Project_ID) : 0,
    open: false,
  };

  async componentDidMount() {
    const { data: Projects } = await getProjects();
    Projects.filter((project) => project.Project_ID !== this.props.Project_ID);
    this.setState({ Projects });
  }

  handleOpen = () => {
    this.props.handleMenuClose();
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleClone = async () => {
    const { data } = await cloneForm(
      this.state.Destination_Project,
      this.state.Form_ID,
      this.state.New_Form_Name
    );
    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projectSettings', 'PROJECT_CLONE_CREATE_FAILED');
    } else {
      toaster('success', data);
      logActivity('/projectSettings', 'PROJECT_CLONE_CREATE_SUCCESS');
      this.setState({ open: false });
    }
  };

  handleChange = ({ target }) => {
    let name = target.name;
    let value = name.includes("Project")
      ? parseInt(target.value)
      : target.value;
    this.setState({ [name]: value });
  };

  render() {
    const { open, Projects, Form_ID, New_Form_Name } = this.state;
    return (
      <React.Fragment>
        <MenuItem onClick={this.handleOpen}>Clone</MenuItem>
        <Dialog
          open={open}
          onClose={this.handleClose}
          maxWidth="sm"
          fullWidth
          aria-labelledby="clone-dialog"
        >
          <DialogTitle id="clone-dialog">Clone Project Form</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please note that only Question/Answer type widget will be cloned.
            </DialogContentText>
            <div className="form-group">
              <label
                className="small mb-1"
                htmlFor={"cloneFormProject" + Form_ID}
              >
                Destination Project
              </label>
              <select
                className="form-control"
                name="Destination_Project"
                id={"cloneFormProject" + Form_ID}
                onChange={this.handleChange}
              >
                {Projects.map((project) => (
                  <option
                    value={project.Project_ID}
                    key={
                      "cloneFormProjectOption" +
                      Form_ID +
                      "_" +
                      project.Project_ID
                    }
                  >
                    {project.Project_Name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label className="small mb-1" htmlFor={"cloneFormName" + Form_ID}>
                New Form Name
              </label>
              <input
                type="text"
                className="form-control"
                name="New_Form_Name"
                id={"cloneFormName" + Form_ID}
                value={New_Form_Name}
                onChange={this.handleChange}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleClone} color="secondary">
              Clone
            </Button>
          </DialogActions>
        </Dialog>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default CloneFormDialog;
